import { render } from "./Calendar.vue?vue&type=template&id=ca2148aa&scoped=true&bindings={}"
import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"

import "./Calendar.vue?vue&type=style&index=0&id=ca2148aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ca2148aa"

export default script